var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "background" }, [
    _c(
      "div",
      { staticClass: "jumbotron_holder" },
      [
        _c(
          "v-jumbotron",
          { attrs: { gradient: _vm.gradient, height: "60vh", width: "60vw" } },
          [
            _c(
              "v-container",
              { attrs: { "fill-height": "" } },
              [
                _c(
                  "v-layout",
                  { attrs: { "align-center": "" } },
                  [
                    _c(
                      "v-flex",
                      [
                        _c("h3", { staticClass: "display-3 title1" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("404")
                          ]),
                          _vm._v(" ERROR.")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "headline title2" }, [
                          _vm._v(
                            "Oops, looks like you've found the wrong page..."
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "title mb-3 middleText1" }, [
                          _vm._v("The page you are looking for can't be found!")
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "mx-0",
                            attrs: {
                              color: "red",
                              depressed: "",
                              large: "",
                              router: "",
                              to: "/"
                            }
                          },
                          [_vm._v("\n              Go to home\n            ")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f37a470", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f37a470","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/page_not_found.vue
// module id = null
// module chunks = 